<template>
    <div class="notice_container">
        <!-- <CustomHeader /> -->
        <div class="headIcon">
            <van-icon name="arrow-left" @click="goToHome" />
        </div>
        <img src="@/assets/common/logo_688v.png" alt="" />
        <p class="titleHead">{{$t('notice.updateNotification')}}</p>
        <div v-html="$t('notice.contentText')"></div>
    </div>
</template>

<script setup lang="ts">
import CustomHeader from '@/components/common/customHeader.vue';
import { defineEmits } from 'vue'

const emits = defineEmits(['goToHome'])

const goToHome = () => {
    emits('goToHome')
}

</script>
<style scoped>
.notice_container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: #fff;
}

.notice_container img {
    width: 50%;
    padding-bottom: 20px;
}

.headIcon {
    position: fixed;
    top: 20px;
    left: 20px;
    font-size: 25px;
}

.titleHead {
    color: orange;
    font-size: 18px;
    font-weight: bold;
}
</style>